import React, { useEffect, useState } from 'react';
import { useResponsive } from '@common-fe/common-fe';

import useFilesInDocumentStore from '@/components/elements/DropScan/useFilesInDocument.store';

import {
  LettersOfMedicalNecessity,
  LMN_UPLOAD_STORE_KEY,
  LMNPopupMode,
  LMNPopupStep,
} from '../LettersOfMedicalNecessity.types';
import { useLettersOfMedicalNecessityPopupStore } from '../stores';

import AssociateWithClaimsPopup from './AssociateWithClaimsPopup/AssociateWithClaimsPopup';
import ClaimsReviewPopup from './ClaimsReviewPopup/ClaimsReviewPopup';
import DocumentPreviewPopup from './DocumentPreviewPopup/DocumentPreviewPopup';
import LettersOfMedicalNecessityErrorPopup from './LettersOfMedicalNecessityErrorPopup/LettersOfMedicalNecessityErrorPopup';

interface Props {
  mode: LMNPopupMode;
  onSetVisible: (value: boolean) => void;
  onSuccess?: (value: string) => void;
  onEdit?: () => void;
  onSuccessEdit?: (value?: LettersOfMedicalNecessity) => void;
  onDelete?: (lmnId: string) => void;
  itemId?: string;
  createForClaimId?: string;
  employeeId?: string;
  disabledClaimSelect?: boolean;
  disableResetDocumentStore?: boolean;
}

const LettersOfMedicalNecessityPopup: React.FC<Props> = ({
  mode,
  itemId,
  onEdit,
  onSetVisible,
  onSuccessEdit,
  onSuccess,
  onDelete,
  createForClaimId,
  employeeId,
  disabledClaimSelect,
  disableResetDocumentStore,
}) => {
  const { isMobile } = useResponsive();
  const [step, setStep] = useState(LMNPopupStep.DOCUMENT_PREVIEW);
  const [isError, setIsError] = useState(false);
  const { handleReset: handleResetDocumentStore } = useFilesInDocumentStore(LMN_UPLOAD_STORE_KEY);
  const { sourceState, handleReset: handleResetLMNPopupStore } = useLettersOfMedicalNecessityPopupStore();

  useEffect(() => {
    return () => {
      if (!disableResetDocumentStore) {
        handleResetDocumentStore();
      }
      handleResetLMNPopupStore();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {step === LMNPopupStep.DOCUMENT_PREVIEW && (
        <DocumentPreviewPopup
          mode={mode}
          onSetVisible={onSetVisible}
          setStep={setStep}
          setIsError={setIsError}
          onSuccess={onSuccess}
          itemId={itemId}
          onEdit={onEdit}
          onSuccessEdit={onSuccessEdit}
          isMobile={isMobile}
          createForClaimId={createForClaimId}
          employeeId={employeeId}
          disabledClaimSelect={disabledClaimSelect}
          onDelete={onDelete}
        />
      )}
      {step === LMNPopupStep.ASSOCIATE_WITH_CLAIMS && (
        <AssociateWithClaimsPopup
          onSetVisible={onSetVisible}
          setStep={setStep}
          setIsError={setIsError}
          onSuccess={onSuccess}
          isMobile={isMobile}
        />
      )}
      {step === LMNPopupStep.CLAIMS_REVIEW_POPUP && (
        <ClaimsReviewPopup onSetVisible={onSetVisible} onSuccess={onSuccess} isMobile={isMobile} />
      )}
      {isError && (
        <LettersOfMedicalNecessityErrorPopup onSetVisible={setIsError} onSubmit={sourceState?.onError} />
      )}
    </>
  );
};

export default LettersOfMedicalNecessityPopup;
